// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogHeader-moduleheader__Ls7gv";
var _2 = "BirdviewChartCatalogHeader-moduletabs__lXLek";
export { _1 as "header", _2 as "tabs" }
